/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { Row, Col, Form, Button } from "react-bootstrap";

import { useAuth, useDispatcher } from "../components/AuthProvider";
import { useUnsecurePost } from "../components/fetchHook";

import getPCPUrl from "../components/pcpUrl";



export default function UserLogin() {
  const navigate = useNavigate();
  const { postData, response, isLoading, error } = useUnsecurePost();

  const [validated, setValidated] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { session } = useAuth();
  const dispatch = useDispatcher();

  const logged_in = session === null ? false : session?.token === undefined ? false : session.token === null ? false : true; // TODO - IsAuthenticaed


  useEffect(() => {
    if (response === null) {
      return;
    }

    let action = {
      type: 'login',
      session: response
    }

    dispatch(action);
    navigate("/app/gallery");

  }, [response]);


  function onUserChanged(event) {
    setUsername(event.target.value);
  }


  function onPasswordChanged(event) {
    setPassword(event.target.value);
  }


  const onSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    if (isLoading === true) {
      return;
    }

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      return;
    }


    let body = {
      "email": username,
      "password": password
    }

    let url = getPCPUrl() + "login";
    await postData(url, JSON.stringify(body));
  }


  function buttonLabel(isTrying) {
    if (isTrying) {
      return <span>Loggin In<i className="fas fa-spinner fa-spin"></i></span>
    }

    return <span>Login</span>
  }


  let error_style = {
    background: "#ffcccc",
    textAlign: "center",

    marginTop: "10px"
  }

  let hr_style = {
    textAlign: "center",

    marginBottom: "10px"
  }

  let signup_style = {
    textAlign: "center",

    marginTop: "10px"
  }


  if (logged_in) {
    return <Navigate to="/app/gallery" replace />;
  }

  return (
    <Row>
      <Col lg={{ span: 6, offset: 3 }}>
        <h2 style={hr_style}>Login</h2>

        <Form noValidate validated={validated} onSubmit={onSubmit}>

          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" placeholder="name@example.com" required value={username} onChange={onUserChanged} />
          </Form.Group>

          <Form.Group className="mb-3" controlId="pass">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" required value={password} onChange={onPasswordChanged} />
          </Form.Group>

          <div className="d-grid ">
            <Button variant="primary" type="submit" >{buttonLabel(isLoading)}</Button>
          </div>

          {error.length > 0 ? <div style={error_style}><p>{error}</p></div> : null}

          <div style={signup_style}>
            <h4>Dont have an Account</h4>
            <Link to="/app/registration">Sign Up Here</Link>
          </div>

        </Form>

      </Col>

    </Row>
  );
};

